import { AdminIntegrationResponse } from '@business/entities/adminIntegration';
import { IntegrationGroup, IntegrationType } from '@business/entities/integration';
import { SettingsResponse } from '@business/entities/settings';
import { SettingsConfig, AppConfig } from '@core/utils/config';
import { R } from '@core/utils/r';

export function isServiceEnabled(integration: IntegrationType) {
  const settings = SettingsConfig.current();
  return !!(settings && settings.integrations.find(i => i.type === integration));
}

export function isQBEnabled() {
  const settings = SettingsConfig.current();
  return !!(settings && settings.integrations.find(i => i.type === IntegrationType.quickbooks));
}

export function findIt(integrations: AdminIntegrationResponse[], type: IntegrationType) {
  const integration = integrations && R.find(integrations, i => i.type === type);
  return integration;
}

export function isRaveVendorEnabled(setting: SettingsResponse | null = null) {
  const settings = setting ? setting : SettingsConfig.current();
  return (
    !!(settings && settings.integrations.find(i => i.type === IntegrationType.ravevendor)) ||
    !!(settings && settings.integrations.find(i => i.type === IntegrationType.ravev2))
  );
}

export function isClickupEnabled(setting: SettingsResponse | null = null) {
  const settings = setting ? setting : SettingsConfig.current();
  return !!(settings && settings.integrations.find(i => i.type === IntegrationType.clickup));
}

export function isRingCentralEnabled(setting: SettingsResponse | null = null) {
  const settings = setting ? setting : SettingsConfig.current();
  return !!(settings && settings.integrations.find(i => i.type === IntegrationType.ringcentral));
}

export function isGroupEnabled(group: IntegrationGroup) {
  const settings = SettingsConfig.current();
  return !!(settings && settings.integrations.find(i => i.group === group));
}

export function isASTEnabled() {
  const settings = SettingsConfig.current();
  const service = settings ? settings.integrations.find(i => i.type === IntegrationType.quickbooks) : undefined;
  return false;
  return !!R.get(service, 'info.isAST', false);
}

export function getIntegrationByGroup(group: IntegrationGroup) {
  const settings = SettingsConfig.current();
  if (settings) {
    return settings.integrations.find(i => i.group === group && i.companyId === AppConfig.current().companyId) || null;
  }
  return null;
}

export function getAllIntegrationByGroup(group: IntegrationGroup) {
  const settings = SettingsConfig.current();
  if (settings) {
    return settings.integrations.filter(i => i.group === group && i.companyId === AppConfig.current().companyId);
  }
  return [];
}

export function isOrderFeeEnabled() {
  return SettingsConfig.current();
}

export function getQbSalesTaxRate() {
  const settings = SettingsConfig.current();
  const service = settings ? settings.integrations.find(i => i.type === IntegrationType.quickbooks) : undefined;
  return R.get(service, 'info.salesTaxCode', null);
}
